// Hero. The whole identity: "water" sits on the flat canvas, then the
// cyan-bordered gradient block begins and "hazard" is cyan — so the colour
// break lands exactly on the waterline (README "Hero"). One gradient in the
// design; the expressive type lives only here.
import { COL, MONO, Medallion } from './primitives';

const WORD: React.CSSProperties = {
  fontSize: 'clamp(58px,17vw,104px)',
  fontWeight: 900,
  letterSpacing: '-0.05em',
};

export function Hero() {
  return (
    <>
      <div style={{ ...COL, padding: '28px 20px 0' }}>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 22 }}>
          <Medallion icon="fish" size={58} iconSize={30} border="rgba(127,227,232,0.55)" />
          <Medallion icon="waves" size={58} iconSize={30} border="rgba(127,227,232,0.55)" />
          <Medallion icon="flag" size={58} iconSize={28} color="var(--orange)" />
        </div>
        <div style={{ ...WORD, lineHeight: 0.84 }}>water</div>
      </div>

      <div
        style={{
          borderTop: '2px solid var(--cyan)',
          background: 'var(--hero-gradient)',
          marginTop: 8,
        }}
      >
        <div style={{ ...COL, padding: '2px 20px 34px' }}>
          <div style={{ ...WORD, lineHeight: 0.9, color: 'var(--cyan)' }}>hazard</div>
          <div
            style={{
              fontFamily: MONO,
              fontSize: 13,
              letterSpacing: '0.18em',
              textTransform: 'uppercase',
              color: 'var(--cyan-soft)',
              marginTop: 6,
            }}
          >
            a mcmahon reunion · summer 2027
          </div>

          <p
            style={{
              fontSize: 'clamp(22px,5.6vw,27px)',
              lineHeight: 1.4,
              fontWeight: 600,
              letterSpacing: '-0.015em',
              margin: '30px 0 0',
              textWrap: 'pretty',
            }}
          >
            somewhere with water on one side and grass on the other, for three or four nights.
          </p>
          <p
            style={{
              fontSize: 'clamp(19px,4.6vw,21px)',
              lineHeight: 1.5,
              color: 'var(--cyan-soft)',
              margin: '14px 0 0',
              textWrap: 'pretty',
            }}
          >
            one uncle wants the ball out of the water. the other is standing in it. everything else is
            undecided.
          </p>

          <a
            href="#respond"
            className="wh-cta on-deep"
            style={{ minHeight: 62, marginTop: 26, fontSize: 21, fontWeight: 700 }}
          >
            tell us what works
          </a>
          <div
            style={{
              fontFamily: MONO,
              fontSize: 13,
              color: 'var(--muted)',
              textAlign: 'center',
              marginTop: 12,
            }}
          >
            2 minutes · we email you a code · no password, no account
          </div>
        </div>
      </div>
    </>
  );
}
